import Vue from "vue"
import App from "./App.vue"
import router from "./router/index.js"


// antd-vue
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
Vue.use(Antd);

// 本地存储
import {getLocalStorage, getSessionStorage, getStorage, setLocalStorage} from "./utils/cookie";

Vue.config.productionTip = false

Vue.prototype.permanentAuth = false;

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);

    // 判断该路由是否需要登录权限
    if (to.matched.some(record => record.meta.requireAuth && record.meta.permanentAuth)) {
        Vue.permanentAuth = true;

        // 缓存考试id
        let match = to.fullPath.match(/\/preview\/(.+)/);
        if (match) {
            let exam = match[1];
            setLocalStorage('exam', exam)
        }

        // 查看是否有token参数
        let isLogin = !!getLocalStorage("token");
        if (to.query && to.query.hasOwnProperty('token') && to.query.token) {
            setLocalStorage('token', to.query.token);
            isLogin = true;
            next();
            return;
        }
        if (isLogin) { // 判断当前是否是登录状态，已登录
            next();
            return
        } else { // 未登录，跳转到登录
            next({
                name: "PermanentLogin",
                query: {
                    from: to.fullPath // 跳转到登录页时，把当前url设置为url参数，以便登录成功，再跳到当前页
                }
            });
            return
        }
    } else if (to.matched.some(record => record.meta.requireAuth && !record.meta.permanentAuth)) {
        // 临时验证
        let isLogin = !!getStorage("token");

        // 缓存考试id
        let match = to.fullPath.match(/\/exam\/(.+)/);
        if (match) {
            let exam = match[1];
            setLocalStorage('exam', exam)
        }

        if (isLogin) { // 判断当前是否是登录状态，已登录
            next();
            return
        } else { // 未登录，跳转到登录
            next({
                name: "Login",
                query: {
                    from: to.fullPath // 跳转到登录页时，把当前url设置为url参数，以便登录成功，再跳到当前页
                }
            });
            return
        }
    }
    if(to.meta.title) {
        document.title = to.meta.title
    }
    next()
});

// router.onError((error) => {
//     const pattern = /Loading chunk chunk-(\w)+ failed/g;
//     const isChunkLoadFailed = error.message.match(pattern);
//     const targetPath = router.history.pending.fullPath;
//     console.log('路由错误', error)
//     if (isChunkLoadFailed) {
//         console.log('chunkLoad错误', error)
//         router.replace(targetPath);
//     }
// });

var app = new Vue({
    router,
    render: h => h(App)
}).$mount("#app");